var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Classes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.996 1.45c0-.18.007-.358 0-.536a.944.944 0 0 0-.938-.913H1.027C.972 0 .918-.002.866.001A.942.942 0 0 0 0 .944c-.002.23 0 .461 0 .691V14.9c0 .063-.002.124.002.188.045.492.442.86.938.865h5.484l-.203-.34-.204-.338c-.176-.297-.352-.592-.531-.888l-1.433-2.372c-.1-.17-.025-.357.122-.463l.938-.678c.113-.083.321-.051.412.052.113.13.224.262.336.393l1.46 1.7c.216.254.435.507.652.763a3.866 3.866 0 0 1 1.95-1.293c.563-.158 1.132-.143 1.709-.143.57 0 1.137.005 1.688.186.757.246 1.41.721 1.89 1.35.317.417.541.894.662 1.397a4.318 4.318 0 0 1 .106.678h3.111c.51-.022.9-.426.908-.94V14.8L20 1.45h-.004zm-5.82 7.29c-.012 1.219-.888 2.328-2.098 2.563a2.65 2.65 0 0 1-2.765-1.212c-.583-.958-.466-2.189.242-3.045a2.634 2.634 0 0 1 2.876-.782 2.652 2.652 0 0 1 1.746 2.465v.011h-.002z",
    fill: "#66788A",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassIcon);
export default __webpack_public_path__ + "static/media/class_icon.4505d8fcda7b67f496e132c32f24c0fd.svg";
export { ForwardRef as ReactComponent };